module.exports = __webpack_public_path__ + "static/clients-769b65f23b53df87914aa1ea7fd02be3.jpg";